import { render, staticRenderFns } from "./IncludedProduct.vue?vue&type=template&id=792bc907&"
import script from "./IncludedProduct.vue?vue&type=script&lang=js&"
export * from "./IncludedProduct.vue?vue&type=script&lang=js&"
import style0 from "./IncludedProduct.vue?vue&type=style&index=0&id=792bc907&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports